import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import SaudeService from '../../../../../../services/saude-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Profissional = () => {
    let { id } = useParams()
    const [nome, setNome] = useState("");
    const [especialidade, setEspecialidade] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchProfissional(id) {
        const response = await SaudeService.saudeEditProfissionais(id);
        setNome(response.data["nome"]);
        setEspecialidade(response.data["especialidade"]);
    }

    useEffect(() => {
        fetchProfissional(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const profissional = await SaudeService.editarProfissionais(id, {
                nome: nome,
                especialidade: especialidade
            })
            if (profissional.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome do Profissional"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="especialidade">
                                <FloatingLabel
                                    label="Especialidade"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="especialidade"
                                        value={especialidade}
                                        onChange={e => setEspecialidade(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/saude/profissionais/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Profissional editado com sucesso!</Alert>
                <Navigate to={'/restrito/saude/profissionais/listar'} />
            </Fragment>
        )
    }
}

export default Profissional;